'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

require('../styles/DefaultButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function DefaultButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? '' : _ref$children,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === undefined ? '' : _ref$spinnerColor,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);

  var classNames = 'cp-default-btn btn-default ' + className;

  return _react2.default.createElement(
    _button2.default,
    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
    children
  );
}

DefaultButton.propTypes = {
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  spinnerColor: _react2.default.PropTypes.string
};
DefaultButton.displayName = 'DefaultButton';

exports.default = DefaultButton;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/default/components/DefaultButton.component.js
// module id = 215
// module chunks = 0 1 3 4 5